import { Directive, Injector, Input, OnDestroy, OnInit, Optional } from '@angular/core';
import { FrameContext } from '@farris/devkit';
import { FilterComponent } from '@farris/ui-filter';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Directive({
  selector: '[farris-filter-binding]'
})
export class FarrisFilterBindingDirective implements OnInit, OnDestroy {
  private $destroy: Subject<any>;
  /**
   * åéç¼å·ï¼é»è®¤ä¸ºfilterConditionList
   */
  @Input('variableCode') variableCode = 'filterConditionList';
  constructor(
    private injector: Injector,
    private frameContext: FrameContext,
    @Optional() private filterComponent: FilterComponent
  ) {
    this.$destroy = new Subject<any>();
  }
  ngOnDestroy(): void {
    if (this.$destroy) {
      this.$destroy.next();
      this.$destroy.complete();
    }
  }
  ngOnInit(): void {
    if (this.filterComponent) {
      this.filterComponent.conditionsChange.pipe(takeUntil(this.$destroy)).subscribe((event: any) => {
        const { data = '[]' } = event || {};
        this.setConditions(data);
      });
    }
  }
  private setConditions(conditions: string) {
    this.frameContext.uiState.setPropertyValue(this.variableCode, conditions);
  }
}
